import { required } from 'vuelidate/lib/validators'

export default {
  company: {
    name: {
      required
    },
    type: {
      required
    },
    slug: {
      required
    },
    contact: {
      required
    },
    phone: {
      required
    },
    mobile: {
      required
    },
    email: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/form/resources/validations.js